import type { Dir } from '@xox/shared'
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from 'lucide-react'

interface Props {
  onMove: (dir: Dir) => void
  disabled?: boolean
  /** The verb in the buttons' labels: "Slide up", "Move up"… */
  verb?: string
}

/** Phone-sized four-way pad for grid games. */
export function DPad({ onMove, disabled = false, verb = 'Slide' }: Props) {
  const btn =
    'flex size-12 items-center justify-center rounded-xl bg-white text-slate-700 shadow-sm ring-1 ring-slate-200 active:scale-95 disabled:opacity-40 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700'
  return (
    <div className="grid grid-cols-3 gap-1.5" role="group" aria-label="Move">
      <span />
      <button
        type="button"
        className={btn}
        onClick={() => onMove('up')}
        disabled={disabled}
        aria-label={`${verb} up`}
      >
        <ArrowUp className="size-5" aria-hidden />
      </button>
      <span />
      <button
        type="button"
        className={btn}
        onClick={() => onMove('left')}
        disabled={disabled}
        aria-label={`${verb} left`}
      >
        <ArrowLeft className="size-5" aria-hidden />
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => onMove('down')}
        disabled={disabled}
        aria-label={`${verb} down`}
      >
        <ArrowDown className="size-5" aria-hidden />
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => onMove('right')}
        disabled={disabled}
        aria-label={`${verb} right`}
      >
        <ArrowRight className="size-5" aria-hidden />
      </button>
    </div>
  )
}
